import PropTypes from 'prop-types';

import { PDP_NAMED_FILTERS } from 'commons/constants';

export const materialPropType = PropTypes.shape({
  materialId: PropTypes.number,
  label: PropTypes.string,
  image: PropTypes.string,
  upholsteryOptionId: PropTypes.number,
  description: PropTypes.string,
  groupName: PropTypes.string,
  tier: PropTypes.number,
  color: PropTypes.string,
  popular: PropTypes.bool,
  pet_friendly: PropTypes.number,
  performance_fabric: PropTypes.number,
  sustainable_fabric: PropTypes.number,
  sku: PropTypes.string,
});

export const productFilterTypes = PropTypes.shape({
  [PDP_NAMED_FILTERS.SAFEGUARD]: PropTypes.number,
  [PDP_NAMED_FILTERS.PETFRIENDLY]: PropTypes.number,
  [PDP_NAMED_FILTERS.VELVET]: PropTypes.number,
  [PDP_NAMED_FILTERS.SUSTAINABLE]: PropTypes.number,
});
